var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { dataimpService } from '~/config/server';
import { NetService } from '~/utils/net.service';
import { Inject, Debounce } from "~/core/decorator";
var UserExportService = /** @class */ (function () {
    function UserExportService() {
    }
    /**
     * 导出人员和花名册
     */
    UserExportService.prototype.exportUserList = function (data, loading) {
        return this.netService.send({
            server: dataimpService.userExportController.exportUserList,
            data: {
                ids: data.ids
            },
            loading: loading
        });
    };
    /**
     * 下载导入花名册模板
     */
    UserExportService.prototype.downloadUserTemplate = function (loading) {
        return this.netService.send({
            server: dataimpService.userExportController.downloadUserTemplate,
            loading: loading
        });
    };
    /**
     * 导入花名册
     */
    UserExportService.prototype.uploadUser = function (fileId, loading) {
        return this.netService.send({
            server: dataimpService.userExportController.uploadUser,
            data: {
                fileId: fileId
            },
            loading: loading
        });
    };
    __decorate([
        Inject(NetService)
    ], UserExportService.prototype, "netService", void 0);
    __decorate([
        Debounce()
    ], UserExportService.prototype, "exportUserList", null);
    __decorate([
        Debounce()
    ], UserExportService.prototype, "downloadUserTemplate", null);
    __decorate([
        Debounce()
    ], UserExportService.prototype, "uploadUser", null);
    return UserExportService;
}());
export { UserExportService };
